export const ANSWER_BATTLE_QUESTION = 'BATTLES_ANSWER_BATTLE_QUESTION'
export const CREATE_BATTLE = 'BATTLES_CREATE_BATTLE'
export const GET_DISPUTE_BATTLE = 'BATTLES_GET_DISPUTE_BATTLE'
export const GET_BATTLE = 'BATTLES_GET_BATTLE'
export const GET_BATTLE_QUESTION = 'BATTLES_GET_BATTLE_QUESTION'
export const GET_OWN_BATTLE = 'BATTLES_GET_OWN_BATTLE'
export const GIVE_UP = 'BATTLES_GIVE_UP'
export const SAVE_BATTLE_OK = 'BATTLES_SAVE_BATTLE_OK'
export const SAVE_BATTLE_ERROR = 'BATTLES_SAVE_BATTLE_ERROR'
export const SET_BATTLE = 'BATTLES_SET_BATTLE'
export const SET_BATTLE_INFO = 'BATTLES_SET_BATTLE_INFO'
export const SET_BATTLE_QUESTION = 'BATTLES_SET_BATTLE_QUESTION'
export const SET_BATTLE_RESUME = 'BATTLES_SET_BATTLE_RESUME'
export const SET_BATTLE_RESULTS = 'BATTLES_SET_BATTLE_RESULTS'
export const SET_USER_BATTLES = 'BATTLES_SET_USER_BATTLES'
export const SET_ALL_USER_BATTLES = 'BATTLES_SET_ALL_USER_BATTLES'
export const SET_INDIVIDUAL_BATTLE = 'BATTLES_SET_INDIVIDUAL_BATTLE'

export const answerBattleQuestion = (question, battle) => {
  return { type: ANSWER_BATTLE_QUESTION, data: { question: question, battle: battle } }
}
export const createBattle = (rival) => {
  return { type: CREATE_BATTLE, data: rival }
}
export const getBattle = (canSet = false) => {
  return { type: GET_BATTLE, data: canSet }
}
export const setUserBattles = (battles) => {
  return { type: SET_USER_BATTLES, data: battles }
}
export const setAllUserBattles = (battles) => {
  return { type: SET_ALL_USER_BATTLES, data: battles }
}
export const getBattleQuestion = () => {
  return { type: GET_BATTLE_QUESTION }
}
export const getOwnBattle = () => {
  return { type: GET_OWN_BATTLE }
}
export const giveUp = () => {
  return { type: GIVE_UP }
}
export const saveBattleOk = () => {
  return { type: SAVE_BATTLE_OK }
}
export const saveBattleError = () => {
  return { type: SAVE_BATTLE_ERROR }
}
export const setBattle = (question) => {
  return { type: SET_BATTLE, data: question }
}
export const setIndividualBattle = (battle) => {
  return { type: SET_INDIVIDUAL_BATTLE, data: battle }
}
export const setBattleInfo = (question) => {
  return { type: SET_BATTLE_INFO, data: question }
}
export const setBattleResume = (question) => {
  return { type: SET_BATTLE_RESUME, data: question }
}
export const setBattleResults = (results) => {
  return { type: SET_BATTLE_RESULTS, data: results }
}
export const setBattleQuestion = (question) => {
  return { type: SET_BATTLE_QUESTION, data: question }
}
